export default "__VITE_ASSET__Cfq97TCE__"